// import React, { useEffect, useState } from 'react';
// import { useForm, Controller } from "react-hook-form";
// import { useSnackbar } from 'notistack';
// import {
//     TextField,
//     Button,
//     FormControl,
//     DialogActions,
//     InputAdornment,
//     Select,
//     MenuItem
// } from '@mui/material';
// import _ from 'lodash';
// import axios from "axios";

// import Loader from 'components/Loader';
// import { countryCode } from 'constants/appData/filters';
// import axiosInstance from "configs/axiosConfig";
// import { APIRouteConstants, dashboardRouteConstants } from "constants/routeConstants";
// import CustomDialog from 'components/Dialog';
// import { handleOpenAuthDialog, updateUserDetail } from 'utils/auth';
// import { API_URL, GLOBAL_COUNTRY_CODE } from 'constants/appConstants'
// import Forgotpassword from 'containers/Forgotpassword';
// import PrivacyPolicy from 'containers/PrivacyPolicy';
// import TermsAndConditions from 'containers/TermsAndConditions';

// export default function AuthDialog({ isAuthDialogOpen, setAuthDialog, refreshUser, logoUrl }) {
//     const { register, formState: { errors }, handleSubmit, control, getValues } = useForm({
//         defaultValues: {
//             first_name: '',
//             last_name: '',
//             mobile_number: '',
//             email: '',
//             password: '',
//             country_code: GLOBAL_COUNTRY_CODE
//         },
//     });
//     const { enqueueSnackbar } = useSnackbar();
//     const [isLoginView, setLoginView] = useState(true);
//     const [loader, setLoader] = useState(false);
//     const [isForgotPass, setIsForgotPass] = useState(false)
//     const [isOpenPrivacy, setOpenPrivacy] = useState(false)
//     const [isOpenTerms, setOpenTerms] = useState(false)

//     const handleLoginView = () => {
//         if (isForgotPass) {
//             setIsForgotPass(false)
//             setLoginView(true)
//         } else {
//             setLoginView(!isLoginView)
//         }
//     }

//     const DialogHeader = (
//         <span className='description'>Please enter your details to {isLoginView ? 'sign in' : 'get started'}.</span>
//     );

//     const DialogAction = (
//         <Button type="submit" color="success" variant="contained">
//             {isLoginView ? 'Sign in' : 'Sign up'}
//         </Button>
//     )

//     const DialogFooter = (
//         <div style={{ textAlign: 'center' }} className='link-wrapper'>
//             <u onClick={handleLoginView}>
//                 <p className="decorated-text description">
//                     {isLoginView && !isForgotPass ?
//                         `Don't have an account? Create account` :
//                         `Already an existing user? Sign in`}
//                 </p>
//             </u>
//         </div>
//     )

//     const privacyStatement = (
//         <div style={{ textAlign: 'center', padding: '0.6rem 2rem' }} className=' link-wrapper'>
//             <u>
//                 <p style={{ fontSize: '15px', }} className="description">
//                     By continuing, you agree to the
//                     <span
//                         className='link-wrapper-underLine'
//                         onClick={() => setOpenTerms(true)}>
//                     {" "} Terms of Service
//                     </span> and  <span
//                     onClick={(e) => {
//                         setOpenPrivacy(true)
//                     }} className='link-wrapper-underLine'>Privacy Policy.</span>
//                 </p>
//             </u>
//         </div>
//     )

//     const getUser = async (token) => {
//         let res = await axios.get(APIRouteConstants.AUTH.ME, {
//             baseURL: API_URL,
//             headers: {
//                 Accept: "application/json",
//                 "domain-name": 'accessories',
//                 Authorization: `Bearer ${token}`,
//             }
//         })
//         let { data, response } = res;

//         if (response
//             && response.status === 401) {
//             // navigate(authRouteConstants.LOGOUT)
//         }

//         if (data && data.success) {
//             const user = data.data;
//             updateUserDetail(user)
//             handleOpenAuthDialog()
//             setLoader(false)
//         }
//     }

//     const doLogin = async (formData) => {
//         setLoader(true)
//         let res = await axiosInstance.post(APIRouteConstants.AUTH.LOGIN, formData)
//         let { data, response } = res;

//         if (response
//             && response.status === 400
//             && response.data) {
//             if (response.data.message) {
//                 enqueueSnackbar(response.data.message, { variant: 'error' });
//                 setLoader(false)
//             } else
//                 for (let i in response.data) {
//                     enqueueSnackbar(response.data[i][0], { variant: 'error' });
//                     setLoader(false)
//                 }
//         }

//         if (data && data.success) {
//             localStorage.setItem('u-access-token', data.access)
//             getUser(data.access)
//         }
//     }

//     const doCreateUser = async (formData) => {
//         setLoader(true)
//         let res = await axiosInstance.post(APIRouteConstants.AUTH.SIGNUP, formData)
//         let { data, response } = res;

//         if (response
//             && response.status === 400
//             && response.data ) {
//                 if (response.data.message) {
//                     enqueueSnackbar(response.data.message, { variant: 'error' })
//                 } else {
//                     for (let i in response.data) {
//                         enqueueSnackbar(_.capitalize(i) + ': ' + response.data[i][0], { variant: 'error' });
//                     }
//                 }
//         }

//         if (!_.isEmpty(data)) {
//             setLoginView(true)
//         }
//         setLoader(false)
//     }

//     const handleAuth = (formData) => {
//         if (isLoginView) doLogin(formData)
//         else {
//             if (formData.mobile_number) {
//                 formData = {
//                     ...formData,
//                     country_code: formData.country_code.dial_code,
//                 }
//             } else {
//                 delete formData['mobile_number']
//                 delete formData['country_code']
//             }
//             doCreateUser(formData)
//         }
//     }

//     const openTermsAndConditions = (value) => {
//         setOpenTerms(value);
//     }

//     const openPrivacyPolicy = (value) => {
//         setOpenPrivacy(value);
//     }

//     return (
//         <div>
//             <CustomDialog
//                 isDialogOpen={isAuthDialogOpen}
//                 setDialogOpen={setAuthDialog}
//                 header={!isForgotPass && DialogHeader}
//                 footer={DialogFooter}
//                 isFormattedDialog={!isForgotPass}
//                 action={DialogAction}
//                 handleForm={handleAuth}
//                 logoUrl={logoUrl}
//                 subFooter={!isForgotPass && privacyStatement}
//             >
//                 <Loader open={loader} />
//                 {!isForgotPass ? (
//                     <div>
//                         {isLoginView ?
//                             <form onSubmit={handleSubmit(handleAuth)}>
//                                 <div className="dialog-body">
//                                     <div className='auth-wrapper form-wrapper'>
//                                         <FormControl className='form-control'>
//                                             <TextField
//                                                 margin="dense"
//                                                 id="email"
//                                                 placeholder="Email"
//                                                 type="email"
//                                                 fullWidth
//                                                 variant="outlined"
//                                                 size="small"
//                                                 InputLabelProps={{ shrink: false }}
//                                                 {...register("email", { required: true })}
//                                                 error={errors.email?.type}
//                                                 helperText={errors.email?.type === "required" && (
//                                                     'Email or Phone number is required'
//                                                 )}
//                                             />
//                                         </FormControl>
//                                         <FormControl className='form-control'>
//                                             <TextField
//                                                 margin="dense"
//                                                 id="name"
//                                                 placeholder="Enter Password"
//                                                 type="password"
//                                                 fullWidth
//                                                 variant="outlined"
//                                                 size="small"
//                                                 // label="Password"
//                                                 InputLabelProps={{ shrink: false }}
//                                                 {...register("password", { required: true })}
//                                                 error={errors.password?.type}
//                                                 helperText={errors.password?.type === "required" && (
//                                                     'Password is required'
//                                                 )}
//                                             />
//                                         </FormControl>
//                                     </div>
//                                 </div>
//                                 <DialogActions className='dialog-action-wrapper'>
//                                     {DialogAction}
//                                 </DialogActions>
//                             </form>
//                             : <form onSubmit={handleSubmit(handleAuth)}>
//                                 <div className="dialog-body">
//                                     <div className='auth-wrapper form-wrapper'>
//                                         <FormControl className='form-control'>
//                                             <TextField
//                                                 margin="dense"
//                                                 id="first_name"
//                                                 placeholder="First Name"
//                                                 type="text"
//                                                 fullWidth
//                                                 variant="outlined"
//                                                 size="small"
//                                                 InputLabelProps={{ shrink: false }}
//                                                 {...register("first_name", { required: true, maxLength: 20 })}
//                                                 error={errors.first_name?.type}
//                                                 helperText={errors.first_name?.type === "required" && (
//                                                     'First name is required'
//                                                 )}
//                                             />
//                                         </FormControl>
//                                         <FormControl className='form-control'>
//                                             <TextField
//                                                 margin="dense"
//                                                 id="last_name"
//                                                 placeholder="Last Name"
//                                                 type="text"
//                                                 fullWidth
//                                                 variant="outlined"
//                                                 size="small"
//                                                 InputLabelProps={{ shrink: false }}
//                                                 {...register("last_name", { required: true, maxLength: 20 })}
//                                                 error={errors.last_name?.type}
//                                                 helperText={errors.last_name?.type === "required" && (
//                                                     'Last name is required'
//                                                 )}
//                                             />
//                                         </FormControl>
//                                         <FormControl className='form-control'>
//                                             <TextField
//                                                 margin="dense"
//                                                 id="email"
//                                                 placeholder="Email"
//                                                 type="email"
//                                                 fullWidth
//                                                 variant="outlined"
//                                                 size="small"
//                                                 InputLabelProps={{ shrink: false }}
//                                                 {...register("email", { required: true, pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i })}
//                                                 error={errors.email?.type}
//                                                 helperText={(errors.email?.type === "required" && (
//                                                     'Email is required'
//                                                 ) || errors.email?.type === "pattern" && (
//                                                     'Email is invalid'
//                                                 ))}
//                                             />
//                                         </FormControl>
//                                         <FormControl fullWidth className='select-wrapper'>
//                                             <Controller
//                                                 control={control}
//                                                 name="mobile_number"
//                                                 rules={{ required: true, maxLength: 10, minLength: 10 }}
//                                                 // defaultValue={contact?.mobile_number}
//                                                 render={({ field: { onChange, value } }) => (
//                                                     <TextField
//                                                         margin="dense"
//                                                         id="name"
//                                                         placeholder="Mobile Number"
//                                                         type="text"
//                                                         fullWidth
//                                                         variant="outlined"
//                                                         size="small"
//                                                         onChange={onChange}
//                                                         value={value}
//                                                         autoComplete='false'
//                                                         InputLabelProps={{ shrink: false }}
//                                                         InputProps={{
//                                                             startAdornment: <InputAdornment position="start">
//                                                                 <Select
//                                                                     labelId="demo-simple-select-label"
//                                                                     id="demo-simple-select"
//                                                                     className="select-input"
//                                                                     label="Status"
//                                                                     size="small"
//                                                                     fullWidth
//                                                                     sx={{
//                                                                         ".MuiOutlinedInput-notchedOutline": { border: 0 },
//                                                                         "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
//                                                                         {
//                                                                             border: 0,
//                                                                         },
//                                                                         "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//                                                                         {
//                                                                             border: 0,
//                                                                         },
//                                                                     }}
//                                                                     renderValue={(selected) => (
//                                                                         <div className="dial-code-wrapper">
//                                                                             <img src={selected.flag} />
//                                                                             {'+' + selected.dial_code}
//                                                                         </div>
//                                                                     )}
//                                                                     defaultValue={GLOBAL_COUNTRY_CODE}
//                                                                     {...register("country_code", { required: true })}
//                                                                     error={getValues()['mobile_number'] && errors.country_code?.type}
//                                                                 >
//                                                                     {countryCode.map((code, index) =>
//                                                                         <MenuItem className="dial-code-wrapper" value={code}>
//                                                                             <img src={code.flag} />
//                                                                             {'+' + code.dial_code}
//                                                                         </MenuItem>
//                                                                     )}
//                                                                 </Select>
//                                                             </InputAdornment>,
//                                                         }}
//                                                     />
//                                                 )}
//                                             />
//                                             <span className="error-text">
//                                                 {(errors.mobile_number?.type === "required" && (
//                                                     'Mobile number is mandatory'
//                                                 ) || errors.mobile_number?.type === "maxLength" && (
//                                                     'Mobile number must be 10 digit in length'
//                                                 ) || errors.mobile_number?.type === "minLength" && (
//                                                     'Mobile number must be 10 digit in length'
//                                                 ))}
//                                                 {/* {getValues()['mobile_number'] && errors.country_code?.type === "required" && (
//                                         'Country code is required'
//                                     )} */}
//                                             </span>
//                                         </FormControl>
//                                         <FormControl className='form-control'>
//                                             <TextField
//                                                 margin="dense"
//                                                 id="password"
//                                                 placeholder="Password"
//                                                 type="password"
//                                                 fullWidth
//                                                 variant="outlined"
//                                                 size="small"
//                                                 InputLabelProps={{ shrink: false }}
//                                                 {...register("password", { required: true, minLength: 6, maxLength: 20 })}
//                                                 error={errors.password?.type}
//                                                 helperText={(errors.password?.type === "required" && (
//                                                     'Password is required'
//                                                 ) || errors.password?.type === "minLength" && (
//                                                     'Password should be atleast 6 character in length'
//                                                 ) || errors.password?.type === "maxLength" && (
//                                                     'Password should not be more than 20 character in length'
//                                                 ))}
//                                             />
//                                         </FormControl>
//                                     </div>
//                                 </div>
//                                 <DialogActions className='dialog-action-wrapper'>
//                                     {DialogAction}
//                                 </DialogActions>
//                             </form>}

//                         <h4 type='button' className='link-wrapper-underLine' onClick={() => setIsForgotPass(true)} style={{ margin: '20px 40px 5px', fontSize: "14px" }}>Forgot password? </h4>
//                     </div>
//                 ) : <Forgotpassword onBack={() => setIsForgotPass(false)} />}

//             </CustomDialog>
//             <PrivacyPolicy isOpen={isOpenPrivacy} openPrivacyPolicy={openPrivacyPolicy}/>
//             <TermsAndConditions isOpen={isOpenTerms} openTermsAndConditions={openTermsAndConditions}/>
//         </div>
//     );
// }

// import React, { useEffect, useState } from 'react';
// import { useForm, Controller } from "react-hook-form";
// import { useSnackbar } from 'notistack';
// import {
//     TextField,
//     Button,
//     FormControl,
//     DialogActions,
//     InputAdornment,
//     Select,
//     MenuItem,
//     CardMedia,
//     Grid
// } from '@mui/material';
// import { Modal, Box, Typography, IconButton } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import _ from 'lodash';
// import axios from "axios";

// import Loader from 'components/Loader';
// import { countryCode } from 'constants/appData/filters';
// import axiosInstance from "configs/axiosConfig";
// import { APIRouteConstants, dashboardRouteConstants } from "constants/routeConstants";
// import CustomDialog from 'components/Dialog';
// import { handleOpenAuthDialog, updateUserDetail } from 'utils/auth';
// import { API_URL, ENABLED_D6_FEATURE, GLOBAL_COUNTRY_CODE } from 'constants/appConstants'
// import Forgotpassword from 'containers/Forgotpassword';
// import PrivacyPolicy from 'containers/PrivacyPolicy';
// import TermsAndConditions from 'containers/TermsAndConditions';
// import { useAuth } from 'oidc-react';
// import { useSelector } from 'react-redux';

// export default function AuthDialog({ isAuthDialogOpen, setAuthDialog, refreshUser, logoUrl }) {
//     const { register, formState: { errors }, handleSubmit, control, getValues } = useForm({
//         defaultValues: {
//             first_name: '',
//             last_name: '',
//             mobile_number: '',
//             email: '',
//             // password: '',
//             country_code: GLOBAL_COUNTRY_CODE
//         },
//     });
//     const { enqueueSnackbar } = useSnackbar();
//     const [isLoginView, setLoginView] = useState(true);
//     const [loader, setLoader] = useState(false);
//     const [isForgotPass, setIsForgotPass] = useState(false)
//     const [isOpenPrivacy, setOpenPrivacy] = useState(false)
//     const [isOpenTerms, setOpenTerms] = useState(false)
//     const [isD6AuthDialogOpen, setisD6AuthDialogOpen] = useState(false)
//     const [isD6AuthDialog, setD6AuthDialog] = useState(false)

//     const auth = useAuth();
//     const handleLoginView = () => {
//         if (isForgotPass) {
//             setIsForgotPass(false)
//             setLoginView(true)
//         } else {
//             setLoginView(!isLoginView)
//         }
//     }

//     const DialogHeader = (
//         <span className='description'>Please enter your details to {isLoginView ? 'sign in' : 'get started'}.</span>
//     );

//     const DialogAction = (
//         <Button type="submit" color="success" variant="contained">
//             {isLoginView ? 'Sign in' : 'Sign up'}
//         </Button>
//     )

//     const DialogFooter = (
//         <div style={{ textAlign: 'center' }} className='link-wrapper'>
//             <u onClick={handleLoginView}>
//                 <p className="decorated-text description">
//                     {isLoginView && !isForgotPass ?
//                         `Don't have an account? Create account` :
//                         `Already an existing user? Sign in`}
//                 </p>
//             </u>
//         </div>
//     )

//     const privacyStatement = (
//         <div style={{ textAlign: 'center', padding: '0.6rem 2rem' }} className=' link-wrapper'>
//             <u>
//                 <p style={{ fontSize: '15px', }} className="description">
//                     By continuing, you agree to the
//                     <span
//                         className='link-wrapper-underLine'
//                         onClick={() => setOpenTerms(true)}>
//                     {" "} Terms of Service
//                     </span> and  <span
//                     onClick={(e) => {
//                         setOpenPrivacy(true)
//                     }} className='link-wrapper-underLine'>Privacy Policy.</span>
//                 </p>
//             </u>
//         </div>
//     )

//     const getUser = async (token) => {
//         let res = await axios.get(APIRouteConstants.AUTH.ME, {
//             baseURL: API_URL,
//             headers: {
//                 Accept: "application/json",
//                 "domain-name": 'accessories',
//                 Authorization: `Bearer ${token}`,
//             }
//         })
//         let { data, response } = res;

//         if (response
//             && response.status === 401) {
//             // navigate(authRouteConstants.LOGOUT)
//         }

//         if (data && data.success) {
//             const user = data.data;
//             updateUserDetail(user)
//             handleOpenAuthDialog()
//             setLoader(false)
//         }
//     }

//     const doLogin = async (formData) => {
//         setLoader(true)
//         let res = await axiosInstance.post(APIRouteConstants.AUTH.LOGIN, formData)
//         let { data, response } = res;

//         if (response
//             && response.status === 400
//             && response.data) {
//             if (response.data.message) {
//                 enqueueSnackbar(response.data.message, { variant: 'error' });
//                 setLoader(false)
//             } else
//                 for (let i in response.data) {
//                     enqueueSnackbar(response.data[i][0], { variant: 'error' });
//                     setLoader(false)
//                 }
//         }

//         if (data && data.success) {
//             localStorage.setItem('u-access-token', data.access)
//             localStorage.setItem('u-refresh-token', data.access)
//             getUser(data.access)
//         }
//     }

//     const doCreateUser = async (formData) => {
//         setLoader(true)
//         let res = await axiosInstance.post(APIRouteConstants.AUTH.SIGNUP, formData)
//         let { data, response } = res;

//         if (response
//             && response.status === 400
//             && response.data ) {
//                 if (response.data.message) {
//                     enqueueSnackbar(response.data.message, { variant: 'error' })
//                 } else {
//                     for (let i in response.data) {
//                         enqueueSnackbar(_.capitalize(i) + ': ' + response.data[i][0], { variant: 'error' });
//                     }
//                 }
//         }

//         // if (!_.isEmpty(data)) {
//         //     setLoginView(true)
//         // }
//       if (data && data.success) {
//         localStorage.setItem('u-access-token', data.access)
//         localStorage.setItem('u-refresh-token', data.refresh)
//         console.log("datafast", data)
//         if (data.message) { enqueueSnackbar(data.message, { variant: 'success' }) }
//         getUser(data.access)
//       }
//       setLoader(false)
//     }

//     const handleAuth = (formData) => {
//         if (isLoginView) doLogin(formData)
//         else {
//             if (formData.mobile_number) {
//                 formData = {
//                     ...formData,
//                     country_code: formData.country_code.dial_code,
//                 }
//             } else {
//                 delete formData['mobile_number']
//                 delete formData['country_code']
//             }
//             doCreateUser(formData)
//         }
//     }

//     const openTermsAndConditions = (value) => {
//         setOpenTerms(value);
//     }

//     const openPrivacyPolicy = (value) => {
//         setOpenPrivacy(value);
//     }

//     const handleLoginD6=()=>{

//     auth.signIn(); // Trigger login flow only when the button is clicked

//         // setisD6AuthDialogOpen(!isD6AuthDialogOpen)
//     }
//     const handleLoginD6Close=()=>{
//         setisD6AuthDialogOpen(!isD6AuthDialogOpen)
//     }

//      const IS_D6_APP= ENABLED_D6_FEATURE.includes(window?.location?.host)
//     return (
//       <div>
//           {/* {isD6AuthDialogOpen && <D6Modal
//             logoUrl={logoUrl}
//             isDialogOpen={isD6AuthDialogOpen}
//             setDialogOpen1={handleLoginD6Close}
//           />} */}
//           <CustomDialog
//             isDialogOpen={isAuthDialogOpen}
//             setDialogOpen={setAuthDialog}
//             header={!isForgotPass && DialogHeader}
//             footer={DialogFooter}
//             isFormattedDialog={!isForgotPass}
//             action={DialogAction}
//             handleForm={handleAuth}
//             logoUrl={logoUrl}
//             subFooter={!isForgotPass && privacyStatement}
//           >
//             <Loader open={loader} />
//             {!isForgotPass ? (
//               <div>
//                 {isLoginView ? (
//                   <form onSubmit={handleSubmit(handleAuth)}>
//                     <div className="dialog-body">
//                       <div className="auth-wrapper form-wrapper">
//                         <FormControl className="form-control">
//                           <TextField
//                             margin="dense"
//                             id="email"
//                             placeholder="Email"
//                             type="email"
//                             fullWidth
//                             variant="outlined"
//                             size="small"
//                             InputLabelProps={{ shrink: false }}
//                             {...register("email", { required: true })}
//                             error={errors.email?.type}
//                             helperText={
//                               errors.email?.type === "required" &&
//                               "Email or Phone number is required"
//                             }
//                           />
//                         </FormControl>
//                         <FormControl className="form-control">
//                           <TextField
//                             margin="dense"
//                             id="name"
//                             placeholder="Enter Password"
//                             type="password"
//                             fullWidth
//                             variant="outlined"
//                             size="small"
//                             // label="Password"
//                             InputLabelProps={{ shrink: false }}
//                             {...register("password", { required: true })}
//                             error={errors.password?.type}
//                             helperText={
//                               errors.password?.type === "required" &&
//                               "Password is required"
//                             }
//                           />
//                         </FormControl>
//                       </div>
//                     </div>
//                     <DialogActions className="dialog-action-wrapper">
//                       {DialogAction}
//                     </DialogActions>
//                     {IS_D6_APP && (
//                       <Grid
//                         item
//                         xs={12}
//                         textAlign={"center"}
//                         sx={{ width: "90%", margin: "auto", mt: 2 }}
//                       >
//                         <Button
//                           variant="contained"
//                           onClick={handleLoginD6}
//                           sx={{ width: "96%", textTransform: "none" }}
//                         >
//                           Login with d6
//                         </Button>
//                       </Grid>
//                     )}
//                   </form>
//                 ) : (
//                   <form onSubmit={handleSubmit(handleAuth)}>
//                     <div className="dialog-body">
//                       <div className="auth-wrapper form-wrapper">
//                         <FormControl className="form-control">
//                           <TextField
//                             margin="dense"
//                             id="first_name"
//                             placeholder="First Name"
//                             type="text"
//                             fullWidth
//                             variant="outlined"
//                             size="small"
//                             InputLabelProps={{ shrink: false }}
//                             {...register("first_name", {
//                               required: true,
//                               maxLength: 20,
//                             })}
//                             error={errors.first_name?.type}
//                             helperText={
//                               errors.first_name?.type === "required" &&
//                               "First name is required"
//                             }
//                           />
//                         </FormControl>
//                         <FormControl className="form-control">
//                           <TextField
//                             margin="dense"
//                             id="last_name"
//                             placeholder="Last Name"
//                             type="text"
//                             fullWidth
//                             variant="outlined"
//                             size="small"
//                             InputLabelProps={{ shrink: false }}
//                             {...register("last_name", {
//                               required: true,
//                               maxLength: 20,
//                             })}
//                             error={errors.last_name?.type}
//                             helperText={
//                               errors.last_name?.type === "required" &&
//                               "Last name is required"
//                             }
//                           />
//                         </FormControl>
//                         <FormControl className="form-control">
//                           <TextField
//                             margin="dense"
//                             id="email"
//                             placeholder="Email"
//                             type="email"
//                             fullWidth
//                             variant="outlined"
//                             size="small"
//                             InputLabelProps={{ shrink: false }}
//                             {...register("email", {
//                               required: true,
//                               pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i,
//                             })}
//                             error={errors.email?.type}
//                             helperText={
//                               (errors.email?.type === "required" &&
//                                 "Email is required") ||
//                               (errors.email?.type === "pattern" &&
//                                 "Email is invalid")
//                             }
//                           />
//                         </FormControl>
//                         <FormControl fullWidth className="select-wrapper">
//                           <Controller
//                             control={control}
//                             name="mobile_number"
//                             rules={{
//                               required: true,
//                               maxLength: 10,
//                               minLength: 10,
//                             }}
//                             // defaultValue={contact?.mobile_number}
//                             render={({ field: { onChange, value } }) => (
//                               <TextField
//                                 margin="dense"
//                                 id="name"
//                                 placeholder="Mobile Number"
//                                 type="text"
//                                 fullWidth
//                                 variant="outlined"
//                                 size="small"
//                                 onChange={onChange}
//                                 value={value}
//                                 autoComplete="false"
//                                 InputLabelProps={{ shrink: false }}
//                                 InputProps={{
//                                   startAdornment: (
//                                     <InputAdornment position="start">
//                                       <Select
//                                         labelId="demo-simple-select-label"
//                                         id="demo-simple-select"
//                                         className="select-input"
//                                         label="Status"
//                                         size="small"
//                                         fullWidth
//                                         sx={{
//                                           ".MuiOutlinedInput-notchedOutline": {
//                                             border: 0,
//                                           },
//                                           "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
//                                             {
//                                               border: 0,
//                                             },
//                                           "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//                                             {
//                                               border: 0,
//                                             },
//                                         }}
//                                         renderValue={(selected) => (
//                                           <div className="dial-code-wrapper">
//                                             <img src={selected.flag} />
//                                             {"+" + selected.dial_code}
//                                           </div>
//                                         )}
//                                         defaultValue={GLOBAL_COUNTRY_CODE}
//                                         {...register("country_code", {
//                                           required: true,
//                                         })}
//                                         error={
//                                           getValues()["mobile_number"] &&
//                                           errors.country_code?.type
//                                         }
//                                       >
//                                         {countryCode.map((code, index) => (
//                                           <MenuItem
//                                             className="dial-code-wrapper"
//                                             value={code}
//                                           >
//                                             <img src={code.flag} />
//                                             {"+" + code.dial_code}
//                                           </MenuItem>
//                                         ))}
//                                       </Select>
//                                     </InputAdornment>
//                                   ),
//                                 }}
//                               />
//                             )}
//                           />
//                           <span className="error-text">
//                             {(errors.mobile_number?.type === "required" &&
//                               "Mobile number is mandatory") ||
//                               (errors.mobile_number?.type === "maxLength" &&
//                                 "Mobile number must be 10 digit in length") ||
//                               (errors.mobile_number?.type === "minLength" &&
//                                 "Mobile number must be 10 digit in length")}
//                             {/* {getValues()['mobile_number'] && errors.country_code?.type === "required" && (
//                                         'Country code is required'
//                                     )} */}
//                           </span>
//                         </FormControl>
//                         {/* <FormControl className="form-control">
//                           <TextField
//                             margin="dense"
//                             id="password"
//                             placeholder="Password"
//                             type="password"
//                             fullWidth
//                             variant="outlined"
//                             size="small"
//                             InputLabelProps={{ shrink: false }}
//                             {...register("password", {
//                               required: true,
//                               minLength: 6,
//                               maxLength: 20,
//                             })}
//                             error={errors.password?.type}
//                             helperText={
//                               (errors.password?.type === "required" &&
//                                 "Password is required") ||
//                               (errors.password?.type === "minLength" &&
//                                 "Password should be atleast 6 character in length") ||
//                               (errors.password?.type === "maxLength" &&
//                                 "Password should not be more than 20 character in length")
//                             }
//                           />
//                         </FormControl> */}
//                       </div>
//                     </div>
//                     <DialogActions className="dialog-action-wrapper">
//                       {DialogAction}
//                     </DialogActions>
//                   </form>
//                 )}

//                 <h4
//                   type="button"
//                   className="link-wrapper-underLine"
//                   onClick={() => setIsForgotPass(true)}
//                   style={{ margin: "20px 40px 5px", fontSize: "14px" }}
//                 >
//                   Forgot password?{" "}
//                 </h4>
//               </div>
//             ) : (
//               <Forgotpassword onBack={() => setIsForgotPass(false)} />
//             )}
//           </CustomDialog>

//         <PrivacyPolicy
//           isOpen={isOpenPrivacy}
//           openPrivacyPolicy={openPrivacyPolicy}
//         />
//         <TermsAndConditions
//           isOpen={isOpenTerms}
//           openTermsAndConditions={openTermsAndConditions}
//         />
//       </div>
//     );
// }

// import React, { useState } from "react";
// import { Modal, Box, TextField, Button, Typography, MenuItem, Select, Grid } from "@mui/material";
// import axios from "axios";

// const SignupModal = ({ open, onClose }) => {
//   const [step, setStep] = useState(1);
//   const [countryCode, setCountryCode] = useState("+27");
//   const [mobile, setMobile] = useState("");
//   const [userData, setUserData] = useState({ firstName: "", lastName: "", email: "" });
//   const [otp, setOtp] = useState("");
//   const [isRegistered, setIsRegistered] = useState(false);
//   const [errors, setErrors] = useState({});

//   const validateMobile = () => /^[0-9]{9}$/.test(mobile);
//   const validateEmail = (email) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

//   const handleback = () => {
//     if (step === 2) {
//       setStep(1)
//     } else if (step === 3) {
//       setStep(2)
//     }
//   }

//   const handleNext = async () => {
//     let newErrors = {};

//     if (step === 1) {
//       if (!validateMobile()) {
//         newErrors.mobile = "Invalid mobile number. Must be 9 digits.";
//       } else {
//         try {
//           // const response = await axios.post("/api/check-user", { mobile });
//           // setIsRegistered(response.data.registered);
//           // setStep(response.data.registered ? 3 : 2);
//           setStep(2);
//           return;
//         } catch (error) {
//           newErrors.mobile = "Failed to verify mobile number.";
//         }
//       }
//     } else if (step === 2) {
//       if (!validateEmail(userData.email)) newErrors.email = "Invalid email format.";
//       if (!userData.firstName) newErrors.firstName = "First Name is required.";
//       if (!userData.lastName) newErrors.lastName = "Last Name is required.";

//       if (Object.keys(newErrors).length === 0) {
//         try {
//           // await axios.post("/api/register", { ...userData, mobile });
//           setStep(3);
//           return;
//         } catch (error) {
//           newErrors.email = "Registration failed. Try again.";
//         }
//       }
//     } else if (step === 3) {
//       try {
//         // await axios.post("/api/verify-otp", { mobile, otp });
//         onClose();
//         setStep(1)
//         setUserData({ firstName: "", lastName: "", email: "" });
//         setMobile("");
//       } catch (error) {
//         newErrors.otp = "Invalid OTP. Try again.";
//       }
//     }

//     setErrors(newErrors);
//   };

//   return (
//     <Modal open={open}
//       onClose={onClose}
//     >
//       <Box
//         sx={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           width: 400,
//           bgcolor: "background.paper",
//           boxShadow: 24,
//           p: 4,
//           borderRadius: 2,
//         }}
//       >
//         {step === 1 && (
//           <>
//            <Grid container spacing={2} alignItems="center"  >
//  <Grid item>

//   <Typography variant="h6">Enter Mobile Number to start your journey</Typography>
//  </Grid>
//   <Grid item xs={3}>
//     <Select
//       fullWidth

//       size="medium"
//       sx={{ fontSize:"0.5rem" }}
//       value={countryCode}
//       onChange={(e) => setCountryCode(e.target.value)}
//     >
//       <MenuItem value={"+27"}>(+27)</MenuItem>
//     </Select>
//   </Grid>

//   {/* Mobile Number TextField */}
//   <Grid item xs={9}>
//     <TextField

//     sx={{ fontSize:"0.8rem" }}
//       fullWidth
//       label="Mobile Number"
//       variant="outlined"
//       size="small"
//       value={mobile}
//       onChange={(e) => setMobile(e.target.value)}
//     />
//   </Grid>
//   <Grid item xs={12}>
//   <Typography texta align="center" sx={{fontSize:"0.8rem", color:"red"}}>
//     {errors.mobile}
//   </Typography>
//   </Grid>
// </Grid>

//           </>
//         )}
//         {step === 2 && (
//           <>
//             <Typography variant="h6">Enter Details</Typography>
//             <TextField
//               fullWidth
//               label="First Name"
//               variant="outlined"
//               margin="normal"
//               size="small"
//               value={userData.firstName}
//               onChange={(e) => setUserData({ ...userData, firstName: e.target.value })}
//               error={!!errors.firstName}
//               helperText={errors.firstName}
//             />
//             <TextField
//               fullWidth
//               label="Last Name"
//               variant="outlined"
//               margin="normal"
//               size="small"
//               value={userData.lastName}
//               onChange={(e) => setUserData({ ...userData, lastName: e.target.value })}
//               error={!!errors.lastName}
//               helperText={errors.lastName}
//             />
//             <TextField
//               fullWidth
//               label="Email"
//               type="email"
//               variant="outlined"
//               margin="normal"
//               size="small"
//               value={userData.email}
//               onChange={(e) => setUserData({ ...userData, email: e.target.value })}
//               error={!!errors.email}
//               helperText={errors.email}
//             />
//           </>
//         )}
//         {step === 3 && (
//           <>
//             <Typography variant="h6">Verify OTP</Typography>
//             <TextField
//               fullWidth
//               label="OTP"
//               variant="outlined"
//               margin="normal"
//               value={otp}
//               onChange={(e) => setOtp(e.target.value)}
//               error={!!errors.otp}
//               helperText={errors.otp}
//             />
//           </>
//         )}
//         <Grid item sx={{ display: "flex" }} spacing={2} justifyContent="space-between">
//           <Button variant="contained" size="small" sx={{ mt: 2 }} onClick={handleback}>
//             Back        </Button>
//           <Button variant="contained" size="small" sx={{ mt: 2 }} onClick={handleNext}>
//             {step === 3 ? "Verify & Continue" : "Next"}
//           </Button>
//         </Grid>
//       </Box>
//     </Modal>
//   );
// };

// export default SignupModal;

import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Typography,
  MenuItem,
  Select,
  Grid,
  DialogContentText,
  Box,
  CardMedia,
  Divider,
  LinearProgress,
  CircularProgress,
  InputAdornment,
  Avatar,
} from "@mui/material";
import axios from "axios";
import { isMobile } from "react-device-detect";
import { Close } from "@mui/icons-material";
import { useAuth } from "oidc-react";
import {
  API_URL,
  ENABLED_D6_FEATURE,
  GLOBAL_COUNTRY_CODE,
} from "constants/appConstants";
import { useModal } from "utils/SignupContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { customeStyle } from "utils/style";
import instance from "configs/axiosConfig";
import { APIRouteConstants } from "constants/routeConstants";
import { enqueueSnackbar, useSnackbar } from "notistack";
import FullScreenLoader from "Context/FullScreenLoader";
import { updateUserDetail } from "utils/auth";
import _ from "lodash";
import { useCart } from "utils/CartContext";
import { useNavigate } from "react-router-dom";
import { clearCart, getCartItemsFromLocalStorage, toAddonsApiPayload } from "utils/cart";
import { updateCartCount } from "utils/website";
import MuiResponsivePhoneInput from "./MuiResponsivePhoneInput";
import { isValidInternationalPhoneNumber, toOrderedForUtc } from "utils/helper";
import { useStore } from "utils/OfflineContext";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import PrivacyPolicy from "containers/PrivacyPolicy";
import TermsAndConditions from "containers/TermsAndConditions";
import d6Logo from "../../assets/images/d6-logo.svg";
const SignupDialog = ({ websiteInfo }) => {
  const { isOpen, openModal, closeModal, loginMessage } = useModal();
  const [isOpenPrivacy, setOpenPrivacy] = useState(false);
  const [isOpenTerms, setOpenTerms] = useState(false);
  const [step, setStep] = useState(1);
  const [countryCode, setCountryCode] = useState("27");
  const [mobile, setMobile] = useState("");
  const [useremail, setUseremail] = useState("");
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiErrors] = useState("");
  const [isRegistered, setIsRegistered] = useState(false);
  const {
    messagefroAuth,
    setmessagefroAuth,
    couponctx,
    orderNotesctx,
    updateCouponctx,
    saveNotectx,
  } = useCart();
  const { pilotPOSContext, setPilotPOSContext } = useStore();
  const auth = useAuth();
  const navigate = useNavigate();

  const validateMobile = () =>
    isValidInternationalPhoneNumber(`+${mobile?.full}`);
  const validateEmail = (email) =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  const validateOtp = (otp) => {
    if (!otp) return "OTP is required.";
    if (!/^\d{5}$/.test(otp)) return "OTP must be 5 digits.";
    return "";
  };

  const handleBack = () => {
    if (isRegistered) {
      setStep(1);
    }
    setApiErrors("");
    setErrors({});
    setStep((prev) => Math.max(1, prev - 1));
  };

  const handleLoginD6 = () => {
    auth.signIn();
  };

  console.log("mobile", mobile);
  const checkMobileExist = async () => {
    console.log("mobile", mobile?.dia);

    const payload = {
      mobile_number: mobile?.number,
      country_code: mobile?.dialCode,
    };

    // return
    try {
      setLoading(true);
      const Response = await instance.post(
        APIRouteConstants.AUTH.MOBILE_CHECK,
        { ...payload },
      );

      return Response?.data;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const getUserDetails = async (category) => {
    try {
      let res = await instance.get(APIRouteConstants.AUTH.ME);
      let { data } = res;

      if (data && !_.isEmpty(data)) {
        localStorage.setItem("u_user_data", JSON.stringify(data));
        updateUserDetail(data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const createUser = async () => {
    const payload = {
      mobile_number: mobile?.number,
      country_code: mobile?.dialCode,
      last_name: userData.lastName,
      first_name: userData.firstName,
      email: userData.email,
    };
    try {
      setLoading(true);

      setApiErrors("");
      const Response = await instance.post(APIRouteConstants.AUTH.CREATE_USER, {
        ...payload,
      });
      if (Response.status === 201) {
        return Response.message;
      }
    } catch (error) {
      const response = error?.response;
      if (response?.status === 400) {
        const mobile = response?.data?.existing_mobile_number;
        setApiErrors(
          `It looks like this email is already in use with the mobile number ${mobile}. Please try using a different one!`,
        );
        return false;
      }
      console.error(error);
      setApiErrors("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const verifyOTP = async () => {
    const payload = {
      mobile_number: mobile?.number,
      country_code: mobile?.dialCode,
      otp: otp,
    };
    try {
      setLoading(true);
      setApiErrors("");
      const Response = await instance.post(APIRouteConstants.AUTH.VERIFY_OTP, {
        ...payload,
      });
      if (Response.status === 200) {
        return Response;
      }
    } catch (error) {
      const response = error?.response;
      const errMsg = response?.data?.error;
      if (response?.status === 400 && errMsg) {
        setApiErrors(errMsg);
        return errMsg;
      }
      console.error(error);
      setApiErrors("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleNext = async () => {
    setErrors({});
    let newErrors = {};
    if (step === 1) {
      if (!validateMobile()) {
        newErrors.mobile = "Invalid mobile number. Please enter a valid number.";
      } else {
        const Checkuser = await checkMobileExist();
        if (Checkuser?.is_registered) {
          setIsRegistered(Checkuser?.is_registered);
          setUseremail(Checkuser?.email);
          setStep(3);
        } else {
          setIsRegistered(false);
          setStep(2);
        }

        return;
      }
    } else if (step === 2) {
      if (!validateEmail(userData.email))
        newErrors.email = "Invalid email format.";
      if (!userData.firstName) newErrors.firstName = "First Name is required.";
      if (!userData.lastName) newErrors.lastName = "Last Name is required.";

      if (Object.keys(newErrors).length === 0) {
        const response = await createUser();
        if (response === false) {
          return;
        } else {
          // alert(`${response}`)
          setStep(3);
        }
        return;
      }
    } else if (step === 3) {
      const otpError = validateOtp(otp);
      if (otpError) {
        setErrors({ otp: otpError });
        return;
      }
      const response = await verifyOTP();
      if (
        response ===
        "Invalid OTP. Please re-enter the correct code and try again."
      ) {
        // alert(`${response}`)
      } else if (response && response?.data && response?.data?.access) {
        localStorage.setItem("u-access-token", response?.data?.access);
        localStorage.setItem("u-refresh-token", response?.data?.refresh);
        closeModal();
        setUserData({ firstName: "", lastName: "", email: "" });
        setMobile("");
        setStep(1);
        setOtp("");
        if (window.location.pathname === "/cart") {
          syncCartFromLocalStorage();
        } else {
          window.location.reload();
        }
      }
    }

    setErrors(newErrors);
  };

  const checkoutCart = async () => {
    setLoading(true);
    let formData = {};
    try {
      // Retrieve table number from localStorage
      const tableNumber = localStorage.getItem("number");
      console.log("Number before checkout:", tableNumber);

      if (tableNumber) {
        formData["number"] = tableNumber;
      }
      const notesFromLocal = localStorage.getItem("localNotes");
      if (notesFromLocal) {
        const parsedNotes = JSON.parse(notesFromLocal);
        if (Array.isArray(parsedNotes) && parsedNotes.length > 0) {
          formData["products"] = parsedNotes;
        }
      }
      if (couponctx) formData["voucher_code"] = couponctx;

      if (pilotPOSContext === true) {
        formData["is_pilot_order"] = pilotPOSContext;
      }

      // The tip is selected on the cart before login and kept in localStorage.
      // This auto-checkout path (triggered right after OTP verify) must forward
      // it, otherwise the order is created without the tip the user chose.
      const tipFromLocal = Number(localStorage.getItem("tip_amount")) || 0;
      if (tipFromLocal > 0) {
        formData["tip_amount"] = tipFromLocal;
      }

      // Same for the "Ordered For" date picked on the cart (stored by the cart
      // as YYYY-MM-DD). Only sent when the store has upcoming orders enabled;
      // a stale saved date from a past day is dropped.
      const orderedFor = localStorage.getItem("delivery_date");
      if (
        websiteInfo?.websiteInfo?.upcoming_order === true &&
        /^\d{4}-\d{2}-\d{2}$/.test(orderedFor || "") &&
        orderedFor > new Date().toISOString().split("T")[0]
      ) {
        formData["ordered_for"] = toOrderedForUtc(orderedFor);
      }

      let res = await instance.post(
        APIRouteConstants.DASHBOARD.CHECKOUT,
        formData,
      );

      // The date belongs to this order only — clear it so the next order
      // doesn't inherit it.
      if (res?.data) localStorage.removeItem("delivery_date");

      // If checkout is successful, navigate to checkout page
      if (
        res?.data?.pilot_response != null &&
        res?.data?.pilot_response?.response?.Status === true
      ) {
        enqueueSnackbar("Order sent to Pilot POS successfully.", {
          variant: "success",
        });
        navigate(`/order-status?orderid=${res?.data?.transaction_id}`, {
          state: { order: res?.data },
        });
      } else if (res.data && res.data.transaction_id) {
        navigate("/checkout", {
          state: { orderId: res?.data?.transaction_id },
        });
      }
    } catch (error) {
      const response = error?.response;

      if (response && (response.status === 400 || response.status === 404)) {
        if (response.data?.error === "Invalid sequence number") {
          enqueueSnackbar("Invalid QR code, Please try again.", {
            variant: "error",
          });
        } else if (
          response.data?.error === "Order note is required for all products."
        ) {
          enqueueSnackbar("Order note is required for all products.", {
            variant: "error",
          });
        } else if (couponctx) {
          setmessagefroAuth(
            response.data?.detail ||
              response.data?.message ||
              "Voucher not found with the specified code or not valid.",
          );
          updateCouponctx("");
          localStorage.removeItem("vouchercode");
        } else if (websiteInfo?.order_note_required) {
          enqueueSnackbar(response.data?.error, { variant: "error" });
        } else {
          enqueueSnackbar(
            "There is some issue while checkout, Please try again..",
            { variant: "error" },
          );
        }
      } else {
        console.error("❌ Checkout error:", error);
        setmessagefroAuth("An error occurred while processing your checkout.");
      }
    }

    setLoading(false);
  };

  const syncCartFromLocalStorage = async () => {
    setLoading(true);
    try {
      let cartItems = getCartItemsFromLocalStorage();
      cartItems = _.map(cartItems, (product) => ({
        product: product.id,
        quantity: product.quantity,
        addons: toAddonsApiPayload(product.selected_addons),
      }));
      let res = await instance.post(
        APIRouteConstants.DASHBOARD.UPDATE_CART_ITEMS_LOCAL_STORAGE,
        cartItems,
      );
      if (res?.status === 201) {
        checkoutCart();
        clearCart();
        updateCartCount(true);
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    setUserData({ firstName: "", lastName: "", email: "" });
    setMobile("");
    setStep(1);
    setOtp("");
    setApiErrors("");
  }, [isOpen]);

  const IS_D6_APP = ENABLED_D6_FEATURE.includes(window?.location?.host);
  return (
    <>
      <Dialog
        open={isOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return; // Prevent closing on backdrop click
          closeModal();
        }}
        fullScreen={false}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: "8px",
            width: { xs: "92%", sm: "100%" },
            maxWidth: "420px",
            m: 0,
            position: "relative",
            p: { xs: 2, sm: 2.5 },
          },
        }}
      >
        {
          <>
            <Close
              sx={{
                position: "absolute",
                top: 16,
                right: 16,
                fontSize: "1.2rem",
                color: "#6b7280",
                cursor: "pointer",
              }}
              onClick={closeModal}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 0.5,
                mt: 0,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 2,
                }}
              >
                <Box
                  component="img"
                  src={
                    websiteInfo?.websiteInfo?.logo ||
                    require("../../assets/images/logo.png")
                  }
                  alt={websiteInfo && websiteInfo.websiteInfo.store_name}
                  sx={{
                    height: 56,
                    maxWidth: IS_D6_APP ? 140 : 200,
                    width: "auto",
                    objectFit: "contain",
                  }}
                />
                {IS_D6_APP && (
                  <>
                    <Divider orientation="vertical" flexItem />
                    <Box
                      component="img"
                      src={d6Logo}
                      alt="D6"
                      sx={{
                        height: 40,
                        width: "auto",
                        objectFit: "contain",
                      }}
                    />
                  </>
                )}
              </Box>
              <Typography
                sx={{
                  fontSize: "0.8rem",
                  fontWeight: 600,
                  color: "#374151",
                  textTransform: "capitalize",
                }}
              >
                {websiteInfo && websiteInfo.websiteInfo.store_name}
              </Typography>
            </Box>
            {loginMessage && (
              <Box
                sx={{
                  background: "#f9f9f9",
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  p: 1.5,
                  mt: 2,
                }}
              >
                <Typography
                  sx={{
                    color: "#000",
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                >
                  🔒 {loginMessage}
                </Typography>
              </Box>
            )}
            {apiError && (
              <Grid textAlign={"center"} mt={2}>
                <Typography
                  sx={{ fontSize: customeStyle.typography.subhading1 }}
                  color={"red"}
                >
                  {apiError}
                </Typography>
              </Grid>
            )}
            {loading ? (
              <Box
                height={"35vh"}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {" "}
                <CircularProgress size={24} color="secondary" />{" "}
              </Box>
            ) : (
              <>
                <DialogTitle
                  sx={{
                    px: 0,
                    pt: 1,
                    pb: 0.25,
                    textAlign: "center",
                    fontWeight: 700,
                    fontSize: step === 3 ? "0.8rem" : "0.95rem",
                    wordBreak: "break-word",
                    color: "#111827",
                  }}
                >
                  {step === 1
                    ? "Welcome!"
                    : step === 2
                      ? "Let's get your profile set up!"
                      : `We've sent an OTP to your email - ${userData?.email || useremail}`}
                </DialogTitle>
                <DialogTitle
                  sx={{
                    px: 0,
                    pt: 0,
                    pb: 0,
                    textAlign: "center",
                    fontWeight: 400,
                    fontSize: "0.7rem",
                    lineHeight: 1.35,
                    color: "#6b7280",
                  }}
                >
                  {step === 1
                    ? "Create an account or log in to continue shopping."
                    : step === 2
                      ? "Just enter the details below to complete it."
                      : `Please enter it to verify your email address.`}
                </DialogTitle>

                <Grid>
                  <DialogContent sx={{ px: 0, pt: 1, pb: 0, overflow: "visible" }}>
                    <Grid>
                      {/* {step === 1 && (
                          <Grid  container spacing={2} alignItems="center" justifyContent={"space-between"} pl={2} mt={0.5} >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                              
                            <MuiResponsivePhoneInput setMobile={setMobile}/>
                            </Grid>
                            {errors.mobile &&
                              <Grid textAlign={'center'} lg={12} md={12} xs={12} mt={1}>
                                <Typography textAlign={'center'} color="error" fontSize={{ xs: "0.7rem", sm: "0.7rem", md: "0.7rem", lg: "0.7rem" }}>{errors.mobile}</Typography>
                              </Grid>
                            }
                          </Grid>
                        )} */}
                      <>
                        {step === 1 && (
                          <Grid
                            container
                            spacing={2}
                            alignItems="center"
                            justifyContent="space-between"
                            px={0}
                          >
                            <Grid item xs={12}>
                              <Typography
                                sx={{
                                  fontSize: "0.8rem",
                                  fontWeight: 600,
                                  color: "#374151",
                                  mb: 0.5,
                                  mt: 0,
                                }}
                              >
                                Mobile number
                              </Typography>
                              <MuiResponsivePhoneInput
                                setMobile={setMobile}
                                error={!!errors.mobile}
                              />
                              <Typography
                                sx={{
                                  mt: 0.75,
                                  fontSize: "0.7rem",
                                  color: "#6b7280",
                                }}
                              >
                                We'll send you an OTP to verify your number.
                              </Typography>
                            </Grid>

                            {errors.mobile && (
                              <Grid item xs={12} sx={{ pt: "8px !important" }}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    color: "#dc2626",
                                  }}
                                >
                                  <ErrorOutlineIcon sx={{ fontSize: "0.9rem" }} />
                                  <Typography
                                    color="inherit"
                                    fontSize="0.75rem"
                                  >
                                    {errors.mobile}
                                  </Typography>
                                </Box>
                              </Grid>
                            )}
                          </Grid>
                        )}
                      </>
                    </Grid>
                    <Grid>
                      {step === 2 && (
                        <Grid sx={{ px: 0 }}>
                          <TextField
                            fullWidth
                            sx={{
                              "& .MuiInputLabel-root": {
                                fontSize: "0.8rem",
                              },
                              "& .MuiInputLabel-shrink": {
                                fontSize: "0.875rem",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "14px",
                              },
                            }}
                            InputProps={{
                              sx: { fontSize: "14px", height: "2rem" },
                            }}
                            label="First Name"
                            variant="outlined"
                            margin="normal"
                            size="small"
                            value={userData.firstName}
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                firstName: e.target.value,
                              })
                            }
                            error={!!errors.firstName}
                            helperText={errors.firstName}
                          />
                          <TextField
                            fullWidth
                            sx={{
                              "& .MuiInputLabel-root": {
                                fontSize: "0.8rem",
                              },
                              "& .MuiInputLabel-shrink": {
                                fontSize: "0.875rem",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "14px",
                              },
                            }}
                            label="Last Name"
                            variant="outlined"
                            margin="normal"
                            size="small"
                            value={userData.lastName}
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                lastName: e.target.value,
                              })
                            }
                            error={!!errors.lastName}
                            helperText={errors.lastName}
                          />
                          <TextField
                            fullWidth
                            sx={{
                              "& .MuiInputLabel-root": {
                                fontSize: "0.8rem",
                              },
                              "& .MuiInputLabel-shrink": {
                                fontSize: "0.875rem",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "14px",
                              },
                            }}
                            label="Email"
                            type="email"
                            variant="outlined"
                            margin="normal"
                            size="small"
                            value={userData.email}
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                email: e.target.value,
                              })
                            }
                            error={!!errors.email}
                            helperText={errors.email}
                          />
                        </Grid>
                      )}
                    </Grid>
                    <Grid sx={{ px: 0 }}>
                      {step === 3 && (
                        <TextField
                          fullWidth
                          label="OTP"
                          sx={{
                            "& .MuiInputLabel-root": {
                              fontSize: "0.8rem",
                            },
                            "& .MuiInputLabel-shrink": {
                              fontSize: "0.875rem",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "14px",
                            },
                          }}
                          size="small"
                          variant="outlined"
                          margin="normal"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          error={!!errors.otp}
                          helperText={errors.otp}
                        />
                      )}
                    </Grid>

                    <Box sx={{ display: "flex", gap: 1.5, mt: 2.5 }}>
                      {step !== 1 && (
                        <Button
                          variant="outlined"
                          onClick={handleBack}
                          startIcon={<ArrowBackIcon />}
                          sx={{
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "0.8rem",
                            borderRadius: "6px",
                            py: 0.75,
                            color: "#111827",
                            borderColor: "#d1d5db",
                            "&:hover": {
                              borderColor: "#9ca3af",
                              background: "#f9fafb",
                            },
                          }}
                        >
                          Back
                        </Button>
                      )}
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={handleNext}
                        endIcon={step !== 3 ? <ArrowForwardIcon /> : null}
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "0.8rem",
                          borderRadius: "6px",
                          py: 0.75,
                          boxShadow: "none",
                          background: "#0b1220",
                          color: "#fff",
                          "&:hover": { background: "#1f2937", boxShadow: "none" },
                        }}
                      >
                        {step === 3 ? "Verify" : step === 1 ? "Continue" : "Next"}
                      </Button>
                    </Box>

                    {IS_D6_APP && step === 1 && (
                      <>
                        <Box
                          sx={{
                            py: 0.75,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Divider sx={{ flex: 1 }} />
                          <Typography
                            sx={{ mx: 2, fontSize: "0.75rem", color: "#6b7280" }}
                          >
                            or
                          </Typography>
                          <Divider sx={{ flex: 1 }} />
                        </Box>
                        <Button
                          variant="outlined"
                          fullWidth
                          onClick={handleLoginD6}
                          startIcon={<LockOutlinedIcon />}
                          sx={{
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "0.8rem",
                            borderRadius: "6px",
                            py: 0.75,
                            color: "#111827",
                            borderColor: "#d1d5db",
                            "&:hover": {
                              borderColor: "#9ca3af",
                              background: "#f9fafb",
                            },
                          }}
                        >
                          Login with D6
                        </Button>
                      </>
                    )}

                    {step === 1 && (
                      <Typography
                        sx={{
                          mt: 1.5,
                          textAlign: "center",
                          fontSize: "0.7rem",
                          color: "#6b7280",
                        }}
                      >
                        By continuing, you agree to our{" "}
                        <Box
                          component="span"
                          onClick={() => setOpenTerms(true)}
                          sx={{
                            color: "#2563eb",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          Terms of Service
                        </Box>{" "}
                        and{" "}
                        <Box
                          component="span"
                          onClick={() => setOpenPrivacy(true)}
                          sx={{
                            color: "#2563eb",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          Privacy Policy
                        </Box>
                        .
                      </Typography>
                    )}
                  </DialogContent>
                </Grid>
              </>
            )}
          </>
        }
      </Dialog>
      <PrivacyPolicy
        isOpen={isOpenPrivacy}
        openPrivacyPolicy={(value) => setOpenPrivacy(value)}
      />
      <TermsAndConditions
        isOpen={isOpenTerms}
        openTermsAndConditions={(value) => setOpenTerms(value)}
      />
    </>
  );
};

export default SignupDialog;
